import {mask} from 'vue-the-mask'
import { toast, loading } from '@/shared/utils/UIHelper'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement'
import state from '@/shared/http/repositories/geo/state'
import ActionsForm from '@/shared/mixins/actionsForm'
import axios from 'axios'

export default{
  mixins: [ActionsForm],
  props: {
    showCreci: {
      type: Boolean,
      default: true
    },
    insertCustomer: {
      type: Boolean,
      default: false
    },
    keyTableUsers: {
      type: Number,
      default: 0
    },
    titleModal: {
      type: String,
      default: 'Adicionar novo registro'
    }

  },
  data () {
    return {
      title: 'Buscar Usuario',
      newUserData: {
        options: [
          { item: 'A', name: '__' }
        ],
        name: '',
        nome: '',
        email: '',
        dataNascimento: null,
        creci: '',
        ufCreciId: '',
        rg: '',
        cpf: '',
        celular: '',
        telefoneComercial: '',
        cep: '',
        cidade: '',
        endereco: '',
        bairro: '',
        numero: '',
        percentualComissao: ''
      },
      statesAcronym: []
    }
  },
  directives: {mask},
  mounted () {
    state.GetAllByCountryID('2375E209-7451-4A7A-A9BE-66BD2C392BE1')
      .then((res) => {
        let stateCompleteData = res.data.data
        stateCompleteData.forEach(stateData => {
          this.statesAcronym.push({value: stateData.id, text: stateData.sigla})
        })
      })
      .catch(() => {})
  },
  methods: {
    formatPercentage (value, e) {
      value = value.replace(/\D/gm, '')
      let valueInt = parseInt(value)

      if (valueInt > 100) {
        value = '100'
      }

      if (valueInt < 1) {
        value = '1'
      }

      if (value !== '' && e.inputType !== 'deleteContentBackward') {
        value += '%'
      }
      return value
    },
    formatLazyPercentage (value) {
      let valueInt = parseInt(value)

      if (valueInt > 100) {
        value = '100'
      }

      if (valueInt < 0) {
        value = '1'
      }
      value += '%'
      return value
    },
    openAddNewUserModal () {
      this.$refs['add-user-modal'].show()
      Object.keys(this.newUserData).forEach(key => {
        if (key === 'dateBirth') {
          this.newUserData[key] = null
        } else {
          this.newUserData[key] = ''
        }
      })
    },
    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then(result => {
        if (!result) {
          return
        }
        this.newUserData.cpf = this.newUserData.cpf.replace(/[().-]/gm, '')
        this.newUserData.celular = this.newUserData.celular.replace(/[().-]/gm, '')
        this.newUserData.telefoneComercial = this.newUserData.telefoneComercial.replace(/[().-]/gm, '')
        this.newUserData.cep = this.newUserData.cep.replace(/[().-]/gm, '')
        if (this.insertCustomer) {
          usermanagement.PostCliente(this.newUserData)
            .then(res => {
              if (res.status === 200) {
                this.$refs['add-user-modal'].hide()
                this.$emit('updateTableCustomers')
                toast.success(`Usuário adicionado com sucesso`)
                loading.pop()
              }
            })
            .catch(() => {
              toast.error(`Erro ao adicionar usuário`)
              loading.pop()
            })
        } else {
          usermanagement.PostCorretor(this.newUserData)
            .then(res => {
              if (res.status === 200) {
                this.$refs['add-user-modal'].hide()
                this.$emit('updateTableUsers')
                toast.success(`Usuário adicionado com sucesso`)
                loading.pop()
              }
            })
            .catch(() => {
              toast.error(`Erro ao adicionar usuário`)
              loading.pop()
            })
        }
      })
    },
    cancelNewUser (e) {
      e.preventDefault()
      this.$refs['add-user-modal'].hide()
      Object.keys(this.newUserData).forEach(key => {
        if (key === 'dateBirth') {
          this.newUserData[key] = null
        } else {
          this.newUserData[key] = ''
        }
      })
    },
    searchAndress () {
      axios({
        method: 'GET',
        url: `https://viacep.com.br/ws/${this.newUserData.cep}/json/`
      }).then(res => {
        if (!('erro' in res.data)) {
          let data = res.data
          if (res.status === 200) {
            this.newUserData.cidade = data.localidade
            this.newUserData.endereco = data.logradouro
            this.newUserData.bairro = data.bairro
          }
        }
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/users/components/UserAddModal/UserAddModal.js